// @flow
export { default } from './Logout';



// WEBPACK FOOTER //
// ./src/pages/logout/index.js